export function getEnv(name) {
    if (window._env_ && window._env_[name]) {
        return window._env_[name]
    }
    return process.env[name]
}
